"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconUnderline', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10.7161 0.800049H12.33V8.323C12.4066 9.57816 12.0054 10.8128 11.2188 11.7425C10.3379 12.5896 9.17837 13.0208 7.9999 12.9394C6.82881 13.0363 5.6702 12.6261 4.781 11.7995C3.99118 10.868 3.58967 9.62902 3.66982 8.3705V0.800049H5.28368V8.47498C5.23817 9.28535 5.48814 10.0828 5.98037 10.6977C6.52616 11.2433 7.257 11.5217 7.9999 11.4671C8.7428 11.5217 9.47364 11.2433 10.0194 10.6977C10.5117 10.0828 10.7616 9.28535 10.7161 8.47498V0.800049ZM2.3999 15.2V13.8322H13.5999V15.2H2.3999Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M13.0241 2H14.8208V10.3754C14.9061 11.7728 14.4595 13.1474 13.5837 14.1824C12.603 15.1255 11.3121 15.6055 10.0001 15.5149C8.69626 15.6228 7.40636 15.1661 6.41641 14.2459C5.53709 13.2089 5.09008 11.8294 5.17931 10.4283V2H6.97604V10.5446C6.92538 11.4468 7.20368 12.3347 7.75168 13.0192C8.35932 13.6266 9.17297 13.9366 10.0001 13.8758C10.8271 13.9366 11.6408 13.6266 12.2484 13.0192C12.7964 12.3347 13.0747 11.4468 13.0241 10.5446V2ZM3.76538 18.2903V16.509H16.2345V18.2903H3.76538Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M16.0744 1.19995H18.4952V12.4844C18.6102 14.3671 18.0084 16.2191 16.8284 17.6137C15.5071 18.8843 13.7678 19.531 12.0001 19.4089C10.2435 19.5544 8.50555 18.939 7.17175 17.6992C5.98702 16.3019 5.38476 14.4434 5.50498 12.5556V1.19995H7.92577V12.7124C7.85751 13.9279 8.23246 15.1241 8.97081 16.0464C9.78949 16.8648 10.8858 17.2824 12.0001 17.2005C13.1144 17.2824 14.2107 16.8648 15.0294 16.0464C15.7677 15.1241 16.1427 13.9279 16.0744 12.7124V1.19995ZM3.6001 22.7482V20.7482H20.4001V22.7482H3.6001Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M21.4325 1.59998H24.6602V16.6459C24.8135 19.1562 24.0111 21.6255 22.4378 23.4849C20.6761 25.1791 18.357 26.0414 16 25.8786C13.6579 26.0725 11.3406 25.252 9.56225 23.5989C7.98261 21.736 7.1796 19.2579 7.33989 16.7409V1.59998H10.5676V16.9498C10.4766 18.5706 10.9765 20.1656 11.961 21.3952C13.0526 22.4864 14.5143 23.0433 16 22.934C17.4858 23.0433 18.9475 22.4864 20.0391 21.3952C21.0236 20.1656 21.5235 18.5706 21.4325 16.9498V1.59998ZM4.80005 30.4V27.6644H27.2001V30.4H4.80005Z'],
  params: {
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;